import { Grid, TableBody, TableCell, TableRow, Typography } from "@mui/material";
import React from "react";
import ExportedProformaEmployeeCostReportSection from "./ExportedProformaEmployeeCostReportSection";
import { ProformaEmployeeCostReportSectionRef } from "../../../models/proforma-employee-cost-report/proforma-employee-cost-report-section-ref";
import { SELECTED_PERIOD } from "../../../utils/constants/employee-cost-report-constants";
import { Header, StyledTable, StyledTableHead } from "../styles";

interface Props {
  costSchemaSections: ProformaEmployeeCostReportSectionRef[];
  selectedPeriod?: SELECTED_PERIOD;
  monthlyView: boolean;
}

const ExportedProformaEmployeeCostReportCostSchema = ({ costSchemaSections, selectedPeriod, monthlyView }: Props) => {
  return (
    <>
      <Grid style={{ width: "48%" }}>
        <StyledTable size="small">
          <StyledTableHead>
            <TableRow>
              <Header colSpan={3}>
                <Typography>Employee cost schema</Typography>
              </Header>
            </TableRow>
            <TableRow>
              <TableCell align="center">Section</TableCell>
              <TableCell align="center">Rate</TableCell>
              <TableCell align="center">
                Amount
                {monthlyView && <Typography variant="body2">(Monthly)</Typography>}
              </TableCell>
            </TableRow>
          </StyledTableHead>
          <TableBody>
            {costSchemaSections.map((section, idx) => {
              const nextSection = costSchemaSections.find(
                (_section) => section.type?.sequence && _section.type?.sequence === section.type?.sequence + 1
              );

              return (
                <React.Fragment key={idx}>
                  <ExportedProformaEmployeeCostReportSection
                    key={idx}
                    section={section}
                    selectedPeriod={selectedPeriod}
                    monthlyView={monthlyView}
                  />
                  {section.type?.legislationEmployeeCostSectionGroup?.id !==
                    nextSection?.type?.legislationEmployeeCostSectionGroup?.id && (
                    <TableRow>
                      <TableCell colSpan={3}></TableCell>
                    </TableRow>
                  )}
                </React.Fragment>
              );
            })}
          </TableBody>
        </StyledTable>
      </Grid>
    </>
  );
};
export default ExportedProformaEmployeeCostReportCostSchema;
